// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { UserCheckIcon } from '@moia-dev/pace-icons'
import { TemporaryBackofficeSessionsAreaRoutes } from './TemporaryBackofficeSessionsAreaRoutes'

export const TemporaryBackofficeSessionsAreaNavigationIcon = UserCheckIcon

export const TemporaryBackofficeSessionsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={TemporaryBackofficeSessionsAreaRoutes.route}
      Icon={UserCheckIcon}
    />
  )
}
